import Vue from "vue";
import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import "./set-public-path";
import singleSpaVue from "single-spa-vue";
import "@/styles/index.scss"; // global css
import App from "./App";
import router from "./router";
import store from "./store";
import lazyload from "vue-lazyload";
import SwUI from "sw-ui";
import "sw-ui/lib/theme-chalk/index.css";

Vue.config.productionTip = false;
Vue.prototype.$serverConfig = {
  CLOSEDURL: process.env.VUE_APP_CLOSEDURL,
  INSTANCE_SEARCH_DATE: process.env.VUE_APP_INSTANCE_SEARCH_DATE,
};

Vue.use(SwUI);

Vue.use(lazyload);
function getQueryString(e) {
  var t = new RegExp("(^|&)" + e + "=([^&]*)(&|$)");
  var search = window.location.search;
  var a = search.substr(1).match(t);
  if (a != null) return a[2];
  return "";
}
if (!window.singleSpaNavigate) {
  // 判断未使用single-spa
  // eslint-disable-next-line no-new
  const token = getQueryString("token") || localStorage.getItem("Admin-Token");
  // const token1 = 'eyJhbGciOiJSUzUxMiJ9.eyJzdWIiOiJzbWFydGFkbWluIiwiaXNzIjoiY2FzLmRlbW8uc3Vwd2lzZG9tLmNvbSIsIkFUVFJfaWRlbnRpdHlUeXBlSWQiOiIxIiwiQVRUUl9hY2NvdW50SWQiOiIxIiwiQVRUUl91c2VySWQiOiIxIiwiQVRUUl9uYW1lIjoi5pm65oWn5qCh5Zut566h55CG5ZGYIiwiQVRUUl9pZGVudGl0eVR5cGVDb2RlIjoiYWRtaW4iLCJBVFRSX2lkZW50aXR5VHlwZU5hbWUiOiLnrqHnkIYiLCJBVFRSX2FjY291bnROYW1lIjoic21hcnRhZG1pbiIsIkFUVFJfb3JnYW5pemF0aW9uTmFtZSI6IuaZuuaFp-Wkp-WtpiIsIkFUVFJfdXNlck5hbWUiOiLmmbrmhafmoKHlm63nrqHnkIblkZgiLCJleHAiOjE2ODIxNDExOTQsIkFUVFJfb3JnYW5pemF0aW9uSWQiOiIxIiwiaWF0IjoxNjgxOTY4Mzk0LCJqdGkiOiJJRC1Ub2tlbi0xNDI2LXkzaDlMR2pyQzNFVlkzNTBoakRHRzVYRFQ2STROLVpYIiwicmVxIjpudWxsLCJBVFRSX29yZ2FuaXphdGlvbkNvZGUiOiIxIn0.kOQXHgRxvZEQzy0Ky34yW3CLk-22X_3qh6xzlwwCD8eFydtexd5MbwdihP7zESMa3VzQdplYf0NJuSZKUhcQy6T1kbrxLcPkheG-SfM6gkH0qoKMSqkm8igctx-6slVo7unaVESBY5QduWKoPTqy1sH9VEWdtsI_ScP28pn28gBiuVe662ViGMkwKEv9NxCtDd0B3kf7gtgk7gLeXjfIRHdKy704lzF4X2Alrtqw49EHwVZWv6oxRimBBGeCtDyubyt_5Lkf9FOJaOwTIdXMy1b-0Pcd65OAvJLkiZ-PrVN0RGlIDP0Lexib0L1f13CEjtWgD2fZrFJQGgeK7PWGEg';
  localStorage.setItem("Admin-Token", token);
  // eslint-disable-next-line no-new
  new Vue({
    el: "#app",
    router,
    store,
    // i18n,
    render: (h) => h(App),
  });
}
const appOptions = {
  router,
  store,
  render: (h) => h(App),
};
if (document.querySelector("#mainApp")) {
  appOptions.el = "#mainApp";
}
// 使用 single-spa
const vueLifecycle = singleSpaVue({
  Vue,
  appOptions: appOptions,
});
export const bootstrap = vueLifecycle.bootstrap;
export const mount = vueLifecycle.mount;
export const unmount = vueLifecycle.unmount;
